import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { LoadingButton } from "@mui/lab";
import "./styles.scss";

type CustomDialogProps = {
  dialogContent: string;
  title: string;
  handleClose: () => void;
  open: boolean;
  primaryBtnText: string;
  secondaryBtnText: string;
  primaryBtnAction: () => void;
  secondaryBtnAction: () => void;
  primaryBtnLoading?: boolean;
  error: string;
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "363px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CustomDialog = (props: CustomDialogProps) => {
  const {
    dialogContent,
    title,
    handleClose,
    open,
    primaryBtnText,
    secondaryBtnText,
    primaryBtnAction,
    secondaryBtnAction,
    primaryBtnLoading,
    error,
  } = props;

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom className="dialog-content">
            {dialogContent}
          </Typography>
        </DialogContent>
        <Typography variant="sFormHelper" className="api-error">
          {error ?? ""}
        </Typography>
        <DialogActions>
          {secondaryBtnText && (
            <Button
              autoFocus
              onClick={secondaryBtnAction}
              className="back-to-login-button"
            >
              {secondaryBtnText}
            </Button>
          )}
          <LoadingButton
            variant="contained"
            data-testid="resetLinkBtn"
            size="small"
            className="send-link-button"
            onClick={primaryBtnAction}
            loading={primaryBtnLoading}
          >
            {primaryBtnText}
          </LoadingButton>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default CustomDialog;
